import { FuelDataAPI } from '../services/gas-station-events.service';

type Cost = {
  ht: number;
  tva: number;
  ttc: number;
  perLiter: number;
};

class GasStationEvent {
  id: number;
  fuelTypeId: number;
  timestamp: number;
  deviceId: number;
  supplier: string; // TotalEnergies Marketing France
  address: string;
  consumption: number;
  cost: Cost;
  driverName: string;
  constructor(fuelDataApi: FuelDataAPI) {
    this.id = fuelDataApi.id_fuel_data;
    this.fuelTypeId = fuelDataApi.fk_fuel_type;
    this.timestamp = fuelDataApi.date_time;
    this.deviceId = fuelDataApi.fk_device;
    this.supplier = fuelDataApi.supplier;
    this.address = fuelDataApi.address;
    this.consumption = fuelDataApi.total_fuel;
    this.driverName = fuelDataApi.driver_name;
    this.cost = {
      ht: fuelDataApi.cost_ht,
      tva: fuelDataApi.cost_tva,
      ttc: fuelDataApi.cost_ttc,
      perLiter: fuelDataApi.unit_price,
    };
  }

  public isInRange(start: number, stop: number) {
    return this.timestamp >= start && this.timestamp < stop;
  }
}

export default GasStationEvent;
